import Keycloak from 'keycloak-js';
import {KEYCLOAK_URL} from '../config/apiConfig';

// Single Keycloak instance — never recreate.
// Initialized once in src/index.js before React renders.
const keycloak = new Keycloak({
    url: KEYCLOAK_URL,
    realm: 'nuto',
    clientId: 'ui-client',
});

export default keycloak;
